import Vue from 'vue'
import Router from 'vue-router'
import * as Public from './modules/public/public'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    Public.Home,
    Public.Expired,
    Public.NotFound,
    {
      path: '/new-features/:type', // e.g. sale, rental, market, need-to-know
      name: 'NewFeatures',
      component: () => import(/* webpackChunkName: "new-features" */ '../views/NewFeatureView'),
      beforeEnter (to, from, next) {
        if (process.env.VUE_APP_MODE === 'develop' ||
            process.env.VUE_APP_MODE === 'staging') {
          document.getElementsByClassName('preload-loader__container')[0].style.display = 'none'
          next()
        }
      },
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})
